import React, { useEffect, useState } from "react";
import DynamicHeader from "../Header/DynamicHeader";
import apis from "../services";
import { showApiErrors } from "../utils";
import { toast } from "react-toastify";
import TwoFactorModal from "../Components/TwoFactorModal";
import Loader from "../utils/Loader";
import { Loader2 } from "lucide-react";

const Profile = () => {
  const [profile, setProfile] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const [twoFactorModal, setTwoFactorModal] = useState(false);

  const userId = localStorage.getItem("userId");

  useEffect(() => {
    const fetchProfile = async () => {
      const res = await apis.getProfileById(userId);
      console.log(res, "---");
      setProfile(res.data.user);
    };
    fetchProfile();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProfile((prev) => ({ ...prev, [name]: value }));
  };

  const handleEdit = () => setShowConfirm(true);

  const handleConfirmYes = () => {
    setEditMode(true);
    setShowConfirm(false);
  };

  const handleConfirmNo = () => setShowConfirm(false);

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      const res = await apis.updateProfileById(userId, profile);
      console.log(res, "---");
      toast.success("Profile updated successfully");
      setEditMode(false);
    } catch (error) {
      showApiErrors(error, "Something went wrong, please try again");
    }
  };

  if (profile === null) {
    return <Loader2 fullscreen={true} />;
  }

  return (
    <div style={{ padding: "10px" }}>
      {showConfirm && (
        <div
          style={{
            position: "fixed",
            left: 0,
            top: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(226, 231, 228, 0.3)",
            zIndex: 1000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              borderRadius: 12,
              padding: 30,
              backgroundColor: "rgba(10, 10, 10, 0.3)",
              minWidth: 300,
              backgroundClip: "padding-box",
              textAlign: "center",
              border: "1px solid rgba(255, 255, 255, 0.18)",
              backdropFilter: "blur(14px)",
              WebkitBackdropFilter: "blur(14px)",
            }}
          >
            <div style={{ fontSize: 18, marginBottom: 15 }}>
              Are you sure you want to edit your profile?
            </div>
            <button
              style={{
                margin: "0 12px 0 0",
                padding: "7px 20px",
                background: "#0176d3",
                color: "#fff",
                border: "none",
                borderRadius: 6,
                cursor: "pointer",
              }}
              onClick={handleConfirmYes}
            >
              Yes
            </button>
            <button
              style={{
                padding: "7px 20px",
                background: "#eee",
                color: "#333",
                border: "none",
                borderRadius: 6,
                cursor: "pointer",
              }}
              onClick={handleConfirmNo}
            >
              No
            </button>
          </div>
        </div>
      )}

      <DynamicHeader />
      <div className="profile-card privacy-policy-container">
        <div className="profile-header">
          {!editMode && (
            <button className="profile-edit-btn" onClick={handleEdit}>
              Edit
            </button>
          )}
        </div>
        <form className="profile-form" onSubmit={handleSave}>
          <div>
            <label>First Name</label>
            <input
              className="profile-input"
              type="text"
              name="firstName"
              value={profile?.firstName}
              disabled={!editMode}
              onChange={handleChange}
            />
          </div>
          <div>
            <label>Last Name</label>
            <input
              className="profile-input"
              type="text"
              name="lastName"
              value={profile?.lastName}
              disabled={!editMode}
              onChange={handleChange}
            />
          </div>
          <div>
            <label>Email</label>
            <input
              className="profile-input"
              type="email"
              name="email"
              value={profile?.email}
              disabled={true} // **ALWAYS disabled!**
              onChange={handleChange}
            />
          </div>
          <div>
            <label>Mobile Number</label>
            <input
              className="profile-input"
              type="text"
              name="phoneNumber"
              value={profile?.phoneNumber}
              disabled={!editMode}
              onChange={handleChange}
            />
          </div>

          <div>
            <label>Plan Type</label>
            <input
              className="profile-input"
              type="text"
              name="planType"
              value={profile?.planType.toUpperCase()}
              disabled={true}
              // onChange={handleChange}
            />

            <button className="profile-edit-btn" disabled={true}>
              Upgrade
            </button>
          </div>

          <div>
            <label>Two Factor Verification</label>
            <input
              className="profile-input"
              type="text"
              name="twoFactorVerification"
              value={
                profile?.twoFactorVerification ? "Verified" : "Not Verified"
              }
              disabled={true}
            />
          </div>

          {editMode && (
            <div className="profile-form-row-span-2">
              <button type="submit" className="profile-save-btn">
                Save Changes
              </button>
            </div>
          )}
        </form>

        {twoFactorModal && (
          <TwoFactorModal
            isOpen={twoFactorModal}
            onClose={() => setTwoFactorModal(false)}
          />
        )}
      </div>
    </div>
  );
};

export default Profile;
